<template>
  <div class="sidebar-toggle" v-bind:class="{ 'sidebar-toggle-solo': solo }">
    <!--<div :style="'position:absolute;z-index:100;transform:translate(-31px,25px);'">-->
    <v-speed-dial direction="bottom" bottom open-on-hover transition="slide-y-transition">
      <template v-slot:activator>
        <v-btn text fab x-small color="grey" v-if="show" @click="hide()">
          <v-icon style="transform:translateX(6px)">mdi-menu</v-icon
          ><v-icon style="transform:translateX(-2px)">mdi-menu-right</v-icon>
        </v-btn>
      </template>
      <v-btn v-if="!solo && company !== null" text fab x-small color="grey" @click="toCompanyView()">
        <v-icon>business</v-icon>
      </v-btn>
      <v-btn v-if="!solo && company !== null" text fab x-small color="grey" @click="toProcessesView()">
        <v-icon>subject</v-icon>
      </v-btn>
      <v-btn v-if="!solo && company !== null" text fab x-small color="grey" @click="toMeasuresView()">
        <v-icon>list</v-icon>
      </v-btn>
      <v-btn v-if="!solo && company !== null" text fab x-small color="grey" @click="toDocumentsView()">
        <v-icon>folder</v-icon>
      </v-btn>
    </v-speed-dial>
  </div>
</template>

<script>
export default {
  name: "SidebarToggleView",
  props: {
    solo: Boolean,
  },
  watch: {
    solo() {
      console.log("solo?", this.solo);
    },
  },
  computed: {
    company() {
      return this.$store.state.originalStore.selectedCompany;
    },
    show: {
      get() {
        return !this.$store.state.originalStore.sidebarVisible;
      },
      set(value) {
        // skip
      },
    },
  },
  created() {
    this.$store.subscribe((mutation, state) => {
      if (mutation.type === "SET_sidebarVisible") {
        this.show = false;
      }
    });
  },
  methods: {
    hide() {
      this.$store.commit("SET_sidebarVisible", true);
    },
    toCompanyView() {
      this.$router.push({ path: "/app/company/" + this.company.id });
    },
    toProcessesView() {
      this.$router.push({ path: "/app/company/" + this.company.id + "/processes" });
    },
    toMeasuresView() {
      this.$router.push({ path: "/app/company/" + this.company.id + "/measures" });
    },
    toDocumentsView() {
      this.$router.push({ path: "/app/company/" + this.company.id + "/documents" });
    },
  },
};
</script>

<style scoped>
.sidebar-toggle {
  position: absolute;
  z-index: 100;
  transform: translate(-31px, 25px);
}
.sidebar-toggle-solo {
  transform: translate(-2px, 40px);
}
</style>
